import { IMenuGroupsFilters } from 'src/view/screens/MenuManagementScreen/screens/MenuGroupsScreen/types/menuGroups';

export const defaultMenuGroupsFilters: IMenuGroupsFilters = {
  search: '',
  sortField: null,
  sortDir: null,
};
